<template>
  <indemnity-show
    :id="$route.params.id"
    :disable-actions="true"
  />
</template>
<script>
	import IndemnityShow from '@/components/payments/payments/Show.vue'
	export default {
		components: {IndemnityShow}
	}
</script>
